// extracted by mini-css-extract-plugin
export default {"datasourceCheckbox":"Datasource_datasourceCheckbox__hPDpA"};